import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { getAdminMe } from "../../services/api";

const BillingSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState<"checking" | "active" | "pending">("checking");

  useEffect(() => {
    // Stripe's webhook updates the subscription asynchronously — poll
    // briefly for it to land rather than assuming it's instant.
    let attempts = 0;
    const maxAttempts = 6;

    const check = async () => {
      attempts += 1;
      try {
        await getAdminMe();
        setStatus("active");
      } catch {
        if (attempts >= maxAttempts) {
          setStatus("pending");
        } else {
          setTimeout(check, 1500);
        }
      }
    };

    check();
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100">
      <div className="w-full max-w-md rounded-lg bg-white p-8 text-center shadow-md">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-green-100">
          <CheckCircle2 className="h-7 w-7 text-green-600" />
        </div>
        <h1 className="mb-2 text-2xl font-semibold text-gray-800">
          Payment Successful
        </h1>
        <p className="mb-6 text-gray-500">
          {status === "checking" &&
            "Confirming your subscription — this only takes a moment..."}
          {status === "active" &&
            "Your plan is active. You're all set to keep using the POS."}
          {status === "pending" &&
            "Your payment went through. It may take a minute for your account to fully update — try continuing below."}
        </p>
        <button
          onClick={() => navigate("/admin")}
          disabled={status === "checking"}
          className="w-full rounded-md bg-blue-600 p-3 font-medium text-white transition hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {status === "checking" ? "Please wait..." : "Continue to Dashboard"}
        </button>
      </div>
    </div>
  );
};

export default BillingSuccess;
